import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  generateRegistrationCodes,
  getResellers,
  updateRegistrationCodeStatus,
} from './admin-access-codes.api';
import { adminAccessCodesQueryKeys } from './admin-access-codes.keys';

export const useAdminAccessCodesResellersQuery = (params, options = {}) =>
  useQuery({
    queryKey: [...adminAccessCodesQueryKeys.resellers(), params ?? {}],
    queryFn: () => getResellers(params),
    ...options,
  });

export const useGenerateAccessCodesMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...mutationOptions } = options;

  return useMutation({
    mutationFn: (payload) => generateRegistrationCodes(payload),
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: adminAccessCodesQueryKeys.codes(),
      });
      await onSuccess?.(...args);
    },
    ...mutationOptions,
  });
};

export const useUpdateAccessCodeStatusMutation = (options = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...mutationOptions } = options;

  return useMutation({
    mutationFn: ({ id, payload }) => updateRegistrationCodeStatus(id, payload),
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: adminAccessCodesQueryKeys.codes(),
      });
      await onSuccess?.(...args);
    },
    ...mutationOptions,
  });
};
